import { createFileRoute, Outlet, useParams } from '@tanstack/react-router'
import { LimitationCard } from '@/entities/limitation'
import { useTask } from '@/shared/api/menu-restriction'

export const Route = createFileRoute(
  '/_auth/canteen/meal-restrictions/restriction/$restrictionId/common'
)({
  component: RouteComponent,
})

function RouteComponent() {
  const { restrictionId } = useParams({
    from: '/_auth/canteen/meal-restrictions/restriction/$restrictionId/common',
  })

  const { task, studentPhotoUrl, isLoading } = useTask({ id: restrictionId })

  return (
    <>
      <LimitationCard
        task={task}
        isLoading={isLoading}
        basePath="canteen"
        studentPhotoUrl={studentPhotoUrl}
      />
      <Outlet />
    </>
  )
}
